/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as TreeMapLayerSpec } from '../../../../layer/preset/treeMap/treeMap';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';
import type { Data } from '../../specProcessor';

export type Spec = BaseSpec;

type TreeMapLayerType = StandardChartLayerSpec & TreeMapLayerSpec & ILayerTypeSpec;

// 创建矩形树图数据类型验证器
const validateTreeMapDataTypes = createDataTypeValidator('treeMap', [
  { field: 'x', type: 'string' },
  { field: 'y', type: 'number' },
  { field: 'color', type: 'number', required: false }
]);

// 创建矩形树图编码验证器
const validateTreeMapEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'color', required: false }
]);

// 额外的检查函数
const additionalTreeMapChecks = (layer: TreeMapLayerType, data: Data) => {
  // 检查数据条数是否满足要求
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];
  if (values.length <= 1) {
    utils.logger.warn('warning', `The "${layer.type}" layer requires more than 1 data points`);
  }
};

// 创建并导出矩形树图处理器
export const treeMap = createLayerProcessor<TreeMapLayerType>(
  'treeMap',
  validateTreeMapEncoding,
  validateTreeMapDataTypes,
  additionalTreeMapChecks
);
